import { CoinBalance, CoinBalanceGraph } from "./types";
import { LOADING_PLACEHOLDER } from "../../constants/common";

export const createBalancesGraph = (values: CoinBalance[]): CoinBalanceGraph[] | null => {
  const totalBalance = values.reduce((acc, coinBalance) => {
    if (coinBalance.balance === LOADING_PLACEHOLDER) return 0;
    const balanceUsd = Number(coinBalance.balance);
    return acc + balanceUsd;
  }, 0);

  if (!totalBalance) return null;
  const valuesWithBalancePercentage = values.map((value) => ({
    ...value,
    percentFromTotal: (Number(value.balance) / totalBalance) * 100,
  }));
  if (valuesWithBalancePercentage) return valuesWithBalancePercentage;
  return null;
};
